<script setup>
import InstitutionSelector from './InstitutionSelector.vue';
</script>

<template>
    <div class="column">
        <div class="is-size-6">Selecione o período:</div>
        <div class="fixed-grid has-6-cols mb-0">
            <div class="grid mb-0">
                <div class="field cell">
                    <label class="label">De</label>
                    <div class="control">
                        <input
                            v-model="form.initialDate"
                            required
                            class="input"
                            type="month"
                            placeholder="Inicial (dd/mm/aaaa)"
                            v-on:change="emitFormChangedEvent()"
                        >
                    </div>
                </div>

                <div class="field cell">
                    <label class="label">Até</label>
                    <div class="control">
                        <input
                            v-model="form.finalDate"
                            required
                            class="input"
                            type="month"
                            placeholder="Final (dd/mm/aaaa)"
                            v-on:change="emitFormChangedEvent()"
                        >
                    </div>
                </div>

                <div class="field cell">
                    <label class="label">Data de citação</label>
                    <div class="control">
                        <input
                            v-model="form.citationDate"
                            required
                            class="input"
                            type="date"
                            placeholder="dd/mm/aaaa"
                            v-on:change="emitFormChangedEvent()"
                        >
                    </div>
                </div>

                <div class="field cell">
                    <label class="label">Honorários</label>
                    <div class="control">
                        <input
                            v-model="form.fee"
                            class="input"
                            type="text"
                            placeholder="Honorários (%)"
                            v-on:change="emitFormChangedEvent()"
                        >
                    </div>
                </div>

                <div class="field cell is-flex">
                    <InstitutionSelector :institutions="institutions" @institutionsSelected="updateInstitutions"/>
                </div>

                <div class="field cell is-flex">
                    <div class="is-align-self-flex-end mb-3">
                        <div class="buttons">
                            <button class="button is-dark" :class="{'is-loading': isLoading}" @click="calculateTax()">Calcular</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid">
                
            </div>
        </div>

        <div class="fixed-grid has-6-cols">
        </div>
    </div>
</template>

<script>

export default {
  data() {
    return {
        isLoading: false,
        form: {
            fee: 0,
            citationDate: new Date().toISOString().slice(0, 10),
            selectedInstitutions: [],
            initialDate: null,
            finalDate: null
        }
    }
  },
  props: ['institutions'],
  methods: {
    emitFormChangedEvent() {
        this.$emit('formChanged', this.form);
    },
    updateInstitutions(selectedInstitutions) {
        this.form.selectedInstitutions = selectedInstitutions;
        this.$emit('formChanged', this.form);
    },
    calculateTax() {
        sessionStorage.setItem('payrollForm', JSON.stringify(this.form));
        this.$emit('calculateTaxes');
        this.isLoading = true;
    }
  }
}
</script>